import $ from 'jquery';
import 'slick-carousel';
import '../polyfill';

let sliders = document.querySelectorAll('.slider');

if (sliders) {
	sliders = Array.from(sliders); // convert NodeList to Array

	[...sliders].forEach(slider => {
		// Loop all sliders
		$(slider).slick({
			slidesToShow: 1,
			accessibility: true,
			focusOnChange: true,
			adaptiveHeight: true,
			dots: true,
			customPaging: function(slider, i) {
				var slideNumber = i + 1,
					totalSlides = slider.slideCount;
				return `<p class="slider-dot"><span class="sr-only">${slideNumber} of ${totalSlides}</span></p>`;
			}
		});
	});
}
